export default {
  namespaced: true,
  state: {
    iconsUrlMap: {}
  },
  getters: {
    getIconsUrlMap: state => state.iconsUrlMap

  },
  mutations: {
    addIconsUrlMap (state, { url, id }) {
      state.iconsUrlMap[id] = url
    },
    clearIconsUrlMap (state, action) {
      state.iconsUrlMap = {}
    }
  }
}
